import axios from 'axios';

export const API_URL = import.meta.env.VITE_API_URL || '/api';

export const TOKEN_KEY = 'beam-token';
export const USER_KEY = 'beam-user';
export const UNAUTHORIZED_EVENT = 'beam:unauthorized';

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401 && localStorage.getItem(TOKEN_KEY)) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
      // AuthContext holds the token in React state; without this the admin shell
      // keeps rendering while every request fails.
      window.dispatchEvent(new CustomEvent(UNAUTHORIZED_EVENT));
    }

    return Promise.reject(error);
  },
);

export const unwrap = (response) => response.data?.data ?? response.data;

/**
 * Turns any axios failure into a single readable sentence, so callers never
 * have to dig through error.response?.data themselves.
 */
export const errorMessage = (error, fallback = '') => {
  const data = error?.response?.data;
  const fromBody =
    typeof data === 'string' && data && !data.trim().startsWith('<')
      ? data
      : data?.message ||
        data?.error ||
        (Array.isArray(data?.errors) ? data.errors.map((item) => item.message).filter(Boolean).join(' ') : '');

  // Prefer the API's own sentence; otherwise the caller's localized fallback.
  // axios messages ("Request failed with status code 500") are for developers,
  // are always English, and tell the operator nothing they can act on.
  return fromBody || fallback || error?.message || 'Request failed.';
};

export const errorStatus = (error) => error?.response?.status ?? 0;
